exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".as[data-v-dcc7730c]{width:100%}.as svg[data-v-dcc7730c]{width:inherit}.as .st0[data-v-dcc7730c],.as .st1[data-v-dcc7730c]{fill:none;stroke:#fff;stroke-miterlimit:10}.as .st1[data-v-dcc7730c]{stroke-linecap:square}.as .st2[data-v-dcc7730c]{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.logo-app[data-v-dcc7730c]{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.logo-app .st0[data-v-dcc7730c]{fill:transparent;stroke:#fff;stroke-width:13px;fill-rule:evenodd;clip-rule:evenodd}.logo-app svg[data-v-dcc7730c]{width:75px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dcc7730c","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/components/BaseLogo.vue
// module id = sfuo
// module chunks = 0